import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
} from "@mui/material";
import { CheckboxWithLabel } from "formik-mui";
import { Field, useFormikContext } from "formik";
import { RigDetailsFormState } from "../FormState";
import { typedPath } from "typed-path";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

const S = typedPath<RigDetailsFormState>();

// this part of the configuration form isn't necessarily worthy of a subform
// yet but this is to pre-organize for when we have more than one hardware
// revision to manage
export const AtkBoardRelaySubform: React.FC<{ readOnly: boolean }> = ({
  readOnly,
}) => {
  let specificConfigSubform: JSX.Element | undefined;
  const { t } = useTranslation();
  const formik = useFormikContext<RigDetailsFormState>();

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (formik.values.atkConfig.relays.mode === "hw20") {
    specificConfigSubform = (
      <>
        <FormControl fullWidth>
          <Field
            component={CheckboxWithLabel}
            type="checkbox"
            name={S.atkConfig.relays.hw20.estopConnected.$path}
            Label={{
              label: t(
                "views.autotractor.rigDetails.configuration.relays.estopConnected"
              ),
            }}
            disabled={readOnly}
          />
        </FormControl>
        <FormControl fullWidth>
          <Field
            component={CheckboxWithLabel}
            type="checkbox"
            name={S.atkConfig.relays.hw20.momentaryEnableConnected.$path}
            Label={{
              label: t(
                "views.autotractor.rigDetails.configuration.relays.momentaryEnableConnected"
              ),
            }}
            disabled={readOnly}
          />
        </FormControl>
        <FormControl fullWidth>
          <Field
            component={CheckboxWithLabel}
            type="checkbox"
            name={S.atkConfig.relays.hw20.momentaryDisableConnected.$path}
            Label={{
              label: t(
                "views.autotractor.rigDetails.configuration.relays.momentaryDisableConnected"
              ),
            }}
            disabled={readOnly}
          />
        </FormControl>
      </>
    );
  }

  return (
    <Accordion className="w-full">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {t("views.autotractor.rigDetails.configuration.relays.sectionHeader")}
      </AccordionSummary>
      <AccordionDetails>{specificConfigSubform}</AccordionDetails>
    </Accordion>
  );
};
